import React from "react";

import Button, { ButtonProps } from "../../../../../components/button/Button";
import useModal from "../../../../../components/dialog/useModal";
import WarningBeforeAction from "../../../../../components/data-components/WarningBeforeAction";
import { warningLeavePageService } from "../../../../../services/page/WarningLeavePageService";

interface ActionButtonProps extends ButtonProps {
  disabled?: boolean;
  className: string;
  textKey: string;
  confirmationButtonTextKey: string;
  confirmationModalTitleKey: string;
  confirmationAction: () => Promise<void>;
  onValidationActionClick?: () => Promise<boolean>;
  children?: any;
  hideCancelButtonOnModal?: boolean;
}

export default function ActionButton(props: ActionButtonProps) {
  const { toggleModal, isVisible } = useModal();

  const {
    disabled,
    className,
    textKey,
    confirmationButtonTextKey,
    confirmationAction,
    confirmationModalTitleKey,
    tooltipKey: tooltip,
    onValidationActionClick,
    hideCancelButtonOnModal,
  } = props;

  const handleConfirmationAction = async () => {
    warningLeavePageService.setIsSubmitting(true);
    await confirmationAction();
    toggleModal();
    warningLeavePageService.reset();
  };

  const handleOnClick = async () => {
    if (!onValidationActionClick) return toggleModal();

    const isValid = await onValidationActionClick();
    if (isValid) return toggleModal();
  };

  return (
    <>
      <Button
        id="action"
        className={className}
        textKey={textKey}
        disabled={disabled}
        onClick={handleOnClick}
        tooltipKey={tooltip}
      />
      <WarningBeforeAction
        isVisible={isVisible}
        titleKey={confirmationModalTitleKey}
        buttonOk={{
          id: "action-button-id",
          textKey: confirmationButtonTextKey,
          action: handleConfirmationAction,
        }}
        toggleModal={toggleModal}
        hideCancelButton={hideCancelButtonOnModal}
      >
        {props.children}
      </WarningBeforeAction>
    </>
  );
}
